module.exports = __webpack_public_path__ + "img/syukyaku-sytem-ira001.f00bef2b.png";